"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPECIALITIES = void 0;
exports.SPECIALITIES = [
    'gyn',
    'hud',
    'pediatrician',
    'fysio',
    'kiro',
    'midwife',
    'PT',
    'plastikk',
];
